import s from './style.css';

const scrollTo = (e, id, block = 'start') => {
	e.preventDefault();
	document.getElementById(id).scrollIntoView({
		block,
		behavior: 'smooth'
	});
};

const NextArrow = ({ to, center }) => (
	<a href={`#${to}`} className={s.root} onClick={e => scrollTo(e, to, center)}>
		<div>
			<svg
				width="40px"
				height="40px"
				viewBox="0 0 40 40"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				className={s.front}
			>
				<title>Next section</title>
				<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					<g stroke="#000000">
						<circle cx="20" cy="20" r="19.5" />
						<path
							fill="transparent"
							stroke="rgba(0, 0, 0, 0.2)"
							d="M20,13.716 C17.712,11.428 14.003,11.428 11.716,13.716 C9.73595207,15.6960479 9.46944864,18.7403208 10.9164897,21.0061981 C11.1415445,21.3586046 11.4080479,21.6921825 11.716,22 L20,30.284 L28.284,22 C28.5915952,21.6925393 28.8578377,21.3593778 29.0827276,21.0074234 C30.5306474,18.7414183 30.2644048,15.6964048 28.284,13.716 C25.996,11.428 22.287,11.428 20,13.716 Z"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<polyline
							stroke-linecap="round"
							stroke-linejoin="round"
							points="11.75 22 20.034 30.284 28.318 22"
						/>
					</g>
				</g>
			</svg>
		</div>
		<div className={s.back}>
			<svg
				width="40px"
				height="40px"
				viewBox="0 0 40 40"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill="#e74347"
					stroke="#000"
					d="M20,13.716 C17.712,11.428 14.003,11.428 11.716,13.716 C9.73595207,15.6960479 9.46944864,18.7403208 10.9164897,21.0061981 C11.1415445,21.3586046 11.4080479,21.6921825 11.716,22 L20,30.284 L28.284,22 C28.5915952,21.6925393 28.8578377,21.3593778 29.0827276,21.0074234 C30.5306474,18.7414183 30.2644048,15.6964048 28.284,13.716 C25.996,11.428 22.287,11.428 20,13.716 Z"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
		</div>
	</a>
);

export default NextArrow;



// WEBPACK FOOTER //
// ./components/NextArrow/index.js